import { useIntl } from "react-intl";

const UnlimitedGoals = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "JiraSoftwarePricingPageTeam24.features.unlimitedGoals.title",
            defaultMessage: "Unlimited goals"
        }),
        body: intl.formatMessage({
            id: "JiraSoftwarePricingPageTeam24.features.unlimitedGoals.content.body",
            defaultMessage:
                "Create goals to align teams and projects to desired outcomes."
        })
    };

    return (
        <div>
            <h2>{messages.title}</h2>
            <p>{messages.body}</p>
        </div>
    );
};

export default UnlimitedGoals;
